import React from 'react';
import Dashboard from '../../components/Dashboard';
import MenuContainer from '../../components/custom-components/menu/MenuContainer';
import AdaptiveContainer from '../../components/containers/AdaptiveContainer';
import ProfileInfoComponent from '../../components/page-components/profile/ProfileInfoComponent';

const ProfileInfo = () => {
    return (
        <Dashboard title='dashboard'>
            <MenuContainer>
                <AdaptiveContainer>
                    <ProfileInfoComponent />
                </AdaptiveContainer>
            </MenuContainer>
        </Dashboard>
    );
};

export default ProfileInfo;
